import { useHostAttribute } from "./useHostAttribute";
import { useComponentContext } from "./useComponentContext";
import { useHost } from "vue";

export const useUidAttribute = () => {
  const context = useComponentContext();
  const host = useHost();

  useHostAttribute(
    () => host,
    "data-uid",
    () => context.uid,
  );
};
